export var LegendMixin = function LegendMixin() {
  return "\n    && {\n        cursor: default;\n    }\n";
};